"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var StringHelper = /*#__PURE__*/function () {
  function StringHelper() {
    (0, _classCallCheck2["default"])(this, StringHelper);
  }

  (0, _createClass2["default"])(StringHelper, null, [{
    key: "getHumanReadableTimeString",
    value: function getHumanReadableTimeString(seconds) {
      var mm = Math.floor(seconds / 60);
      var ss = Math.floor(seconds - mm * 60);
      var res;

      if (ss === 0) {
        res = "" + mm + ":" + ss + "0";
      } else if (ss < 10) {
        res = "" + mm + ":0" + ss;
      } else {
        res = "" + mm + ":" + ss;
      }

      return res;
    }
    /**
     * Returns the given text with all &shy; replaced by equivalent UTF-8 symbol \u00AD
     */

  }, {
    key: "decodeHtmlEntities",
    value: function decodeHtmlEntities(text) {
      if (!text) {
        return null;
      }

      return text.replace(/&shy;/g, "\xAD") // shy
      .replace(/&nbsp;/g, "\xA0") // non breaking space
      .replace(/&#?[a-zA-Z0-9]{2,8};/g, ''); // hide all other symbols to be backward compatible in future
    }
  }, {
    key: "stringifyAnything",
    value: function stringifyAnything(element) {
      if (typeof element === 'string') {
        return element;
      } else {
        try {
          return (0, _stringify["default"])(element);
        } catch (e) {
          return util.inspect(element);
        }
      }
    }
  }]);
  return StringHelper;
}();

exports["default"] = StringHelper;
(0, _defineProperty2["default"])(StringHelper, "removeLeadingAndTrailingBrAndPInHtml", function (htmlString) {
  var regex = /^(<\/?\s*(br|p)[^>]*\/?>)+|(<\/?\s*(br|p)[^>]*\/?>)+$/g;
  return htmlString.replace(regex, '');
});
(0, _defineProperty2["default"])(StringHelper, "removeAllPAndReplaceWithBr", function (htmlString) {
  var regex = /<p[^>]*>/g;
  var stringToReturn = htmlString.replace(regex, '');
  var regex2 = /<\/p[^>]*>/g;
  var stringToReturn2 = stringToReturn.replace(regex2, '<br /><br />');
  var regex3 = /<br \/><br \/>$/g;
  return stringToReturn2.replace(regex3, '');
});
(0, _defineProperty2["default"])(StringHelper, "isEmailAdress", function (address) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(address.toLowerCase());
});
(0, _defineProperty2["default"])(StringHelper, "getMathMlContent", function (htmlString) {
  if (!htmlString) {
    console.log('got no html string', htmlString);
    return null;
  }

  var regex = /<math.*?>.*?<\/math>/g;
  return htmlString.match(regex);
});
(0, _defineProperty2["default"])(StringHelper, "createUuid", function () {
  var d = new Date().getTime();

  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now(); // use high-precision timer if available
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0; // eslint-disable-line

    d = Math.floor(d / 16); // eslint-disable-line

    return (c === 'x' ? r : r & 0x3 | 0x8).toString(16); // eslint-disable-line
  });
});
(0, _defineProperty2["default"])(StringHelper, "getDeviceUuidVisiblePart", function (deviceUuid) {
  if (deviceUuid.split) {
    var parts = deviceUuid.split('-');

    if (parts.length > 0) {
      return parts[parts.length - 1];
    }
  }

  return null;
});
(0, _defineProperty2["default"])(StringHelper, "createShortId", function () {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
  // eslint-disable-line no-magic-numbers
  return Math.random().toString(36).substring(2, length + 2); // eslint-disable-line no-magic-numbers
});
(0, _defineProperty2["default"])(StringHelper, "getDjb2HashCode", function (str) {
  var hash = 5381;

  for (var i = 0; i < str.length; i++) {
    var _char = str.charCodeAt(i);

    hash = (hash << 5) + hash + _char; // hash = hash * 33 + c
  }

  return hash;
});